/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEscalationPriority } from './ControlEscalationPriority';
import {
    ControlEscalationPriorityFromJSON,
    ControlEscalationPriorityFromJSONTyped,
    ControlEscalationPriorityToJSON,
} from './ControlEscalationPriority';

/**
 * 
 * @export
 * @interface ControlUserContactInfoResponse
 */
export interface ControlUserContactInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlUserContactInfoResponse
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserContactInfoResponse
     */
    client_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserContactInfoResponse
     */
    org_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserContactInfoResponse
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserContactInfoResponse
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserContactInfoResponse
     */
    last_name?: string;
    /**
     * 
     * @type {ControlEscalationPriority}
     * @memberof ControlUserContactInfoResponse
     */
    escalation_priority?: ControlEscalationPriority;
    /**
     * 
     * @type {boolean}
     * @memberof ControlUserContactInfoResponse
     */
    is_primary_security_contact?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlUserContactInfoResponse
     */
    is_policyholder?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlUserContactInfoResponse
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserContactInfoResponse
     */
    updated_at: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserContactInfoResponse
     */
    last_confirmed_at: string;
}

/**
 * Check if a given object implements the ControlUserContactInfoResponse interface.
 */
export function instanceOfControlUserContactInfoResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "client_id" in value;
    isInstance = isInstance && "created_at" in value;
    isInstance = isInstance && "updated_at" in value;
    isInstance = isInstance && "last_confirmed_at" in value;

    return isInstance;
}

export function ControlUserContactInfoResponseFromJSON(json: any): ControlUserContactInfoResponse {
    return ControlUserContactInfoResponseFromJSONTyped(json, false);
}

export function ControlUserContactInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlUserContactInfoResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'client_id': json['client_id'],
        'org_id': !exists(json, 'org_id') ? undefined : json['org_id'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'escalation_priority': !exists(json, 'escalation_priority') ? undefined : ControlEscalationPriorityFromJSON(json['escalation_priority']),
        'is_primary_security_contact': !exists(json, 'is_primary_security_contact') ? undefined : json['is_primary_security_contact'],
        'is_policyholder': !exists(json, 'is_policyholder') ? undefined : json['is_policyholder'],
        'created_at': json['created_at'],
        'updated_at': json['updated_at'],
        'last_confirmed_at': json['last_confirmed_at'],
    };
}

export function ControlUserContactInfoResponseToJSON(value?: ControlUserContactInfoResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'client_id': value.client_id,
        'org_id': value.org_id,
        'phone': value.phone,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'escalation_priority': ControlEscalationPriorityToJSON(value.escalation_priority),
        'is_primary_security_contact': value.is_primary_security_contact,
        'is_policyholder': value.is_policyholder,
        'created_at': value.created_at,
        'updated_at': value.updated_at,
        'last_confirmed_at': value.last_confirmed_at,
    };
}

